import React from 'react';
import {useTranslation} from 'react-i18next';

import {SingleCheckBox} from '../../../ui-toolkit/indexExportV2';

function BoolCheckboxFormatter({fieldName}) {
    const {t} = useTranslation();
    return <SingleCheckBox name={fieldName} label={t('boolEditor.yes')} />;
}

export default BoolCheckboxFormatter;
